import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";
import { createGridConfig, gridEditable } from "./gridSettings/gridSettings";
export const allegatiForm: AnaColumn[] = [

    { 
      itemType: "group", colCount: "1",class:'float-start', data:[
        { height:150,width:150,colVisible: true, type: 'campoImmagine', dataField: "img",class:"m-2 ps-3 ext",caption: "Immagine",labelVisible:false,src:'' ,dataType: "" }, //Campo per l'immagine
     {
        type: 'simpleButton', colVisible: false, 
        dataField: "uploadFile", 
        class:'uploadAllegati text-center',
        caption: "Carica File",
        width: 20 + 'vw',
           
        button: {
          text: 'Carica File',
          name: 'caricaFile',
          location: 'after',
          event: "caricaFile",
          hint: "Carica File Allegato",
          icon:'webrifiuti icon-upload-2',
          class:'uploadAllegati ms-3',
          outPutValue: false,
        }
      }
      

    ]},
      


    {

        itemType: "group", colCount: "1",class:'float-end', data: [
          { dataField: "id", colVisible: false, type: 'campo', dataType: "", caption: "ID", hideOnEdit: true, },
          { dataField: "nomeTabella", type: 'campo', colVisible: false, dataType: "", hideOnEdit: true, },
          { dataField: "idTabella", type: 'campo', colVisible: false, dataType: "", hideOnEdit: true, },
              
          {
            maxLength: "60", maxSize: 60, type: 'campo', dataField: "fileOrigine", caption: "Nome", colSpan: '1', //nome del file
            width: 415,hideOnEdit:false,colVisible:true,disabled:true,disableOnUpdate:false,editorClass:'bg-grey',colWidth:'auto',
            validation: [{ type: "required", message: "Campo Obbligatorio, si prega di caricare un file" }],
          },


          { type: 'empty', dataField: '', colVisible: false, dataType: '' },

          { maxLength: "255", height:150,width:415,colVisible: true,hideOnEdit:false,colWidth:'350',maxSize: 255, type: 'campo', dataField: "note", caption: "Descrizione",colCaption:"Descrizione", dataType: "", editorType: "dxTextArea" },
          {
            type:'campo',hideOnEdit:true,dataField:'idTag',class:'d-none',colVisible:false,
          },
          {
            type: 'campoSpecial',colVisible: true,
            dataField: 'descrizioneTag',
            dataType: "",
            hideOnEdit: false,
            disableOnUpdate:true,
            caption: "Tag",
            //groupIndex:0,
            colWidth:60,colSpan:'2',
            showClearButton:true,
            dynamic: {
              componentType: 'dynamicGrid',
              costantValue: [{ key: 'nomeTabella', value: 'sedi' }],
              caption:'Elenco Tags',
              dataSource: `AllegatoTag`,
              valueExpr: '',
              service:'tagAllegati',
              displayExpr: 'descrizione',
              autocomplete:false,
              static: false,
              related:['id|idTag'],
              buttonOption: {
                //text: 'isoFiscale',
                icon: 'glyphicon mdi mdi-playlist-plus',
                hint: 'Elenco Tags',
                name: 'descrizioneTag',
                location: 'after',
              },
              settingGrid: createGridConfig({
               ...gridEditable,
                height:700,
                mode:'row',
                allowUpdating: true,
                allowDeleting: true,
                allowAdding: true,
                colonne: [
                  {
                    dataField:'descrizione',
                    caption:'Descrizione',
                    dataType:'',                 
                  },
                ],
    
              }),
  
            },
          },
          {
            maxLength: "60", maxSize: 60, type: 'campo', dataField: "parolaChiave", caption: "Parola Chiave", colSpan: '1', //nome del file
            width: 200,hideOnEdit:false,colVisible:true,disabled:false,disableOnUpdate:false,
          }, //,editorClass:'bg-grey'
          
          /*
            Button lente di ingrandimento
          */
          {
            type: 'button', dataField: "", colVisible: true, dataType: "", hideOnEdit: true,colWidth:'50px',class:'text-center',horizontalAlignment:'center',
            showEditorAlways:true,
            button: {
              name: 'anteprimaAllegato',
              hint: 'Scarica Allegato',
              icon: 'export icon-download-1',    // devextreme: 'search',
              text: 'Scarica Allegato',
              type: 'text',
              
              class:'anteprimaAllegato',
              event: 'anteprimaAllegato'
            }
          },
          
          /*
          {
            type: 'button', dataField: "", colVisible: true, dataType: "", hideOnEdit: true,
    
            button: {
              name: 'scaricaAllegato',
              hint: 'Scarica Allegato',
              icon: 'download',
              text: 'Scarica',
              type: 'text',
              event: 'scaricaAllegato'
            }
          },
          */
        ]
      },



];

export const allegatiGriglia: AnaColumn[] = [

  {

      itemType: "group", colCount: "1", data: [
        { dataField: "id", colVisible: false, type: 'campo', dataType: "", caption: "ID", hideOnEdit: true, },
        { dataField: "nomeTabella", type: 'campo', colVisible: false, dataType: "", hideOnEdit: true,orderGriglia:0,sortOrder:'desc'},
        { dataField: "idTabella", type: 'campo', colVisible: false, dataType: "", hideOnEdit: true, },
        /*
          Button per Download
        */
          {
            type: 'button', dataField: "", colVisible: true, dataType: "", hideOnEdit: true,colWidth:'50px',class:'text-center',horizontalAlignment:'center',
            button: {
              name: 'anteprimaAllegato',
              hint: 'Scarica Allegato',
              icon: 'export icon-download-1',    // devextreme: 'search',
              text: 'Scarica Allegato',
              type: 'text',
              
              class:'anteprimaAllegato',
              event: 'anteprimaAllegato'
            }
          },
        {
          maxLength: "60", maxSize: 60, type: 'campo', dataField: "fileOrigine", caption: "Nome", colSpan: '1', //nome del file
          width: 415,hideOnEdit:false,colVisible:true,disabled:true,disableOnUpdate:false,colWidth:'200px',
        },

        { maxLength: "255", height:150,width:415,colVisible: true,hideOnEdit:false,colWidth:'200px',maxSize: 255, type: 'campo', dataField: "note", caption: "Descrizione",colCaption:"Descrizione", dataType: "", editorType: "dxTextArea" },
        {
          colWidth:'200px',
          type: 'campoSpecial', dataField: "idTag", dataType: "", caption: "Tag",
          colSpan: "1",       
          lista: {
              static:false,
              caption:'Tag',
              dataSource: 'allegatoTag', 
              valueExpr: 'id', 
              displayExpr: 'descrizione',        
            },

          editorType: 'dxSelectBox'
      },

        {
          maxLength: "60", maxSize: 60, type: 'campo', dataField: "parolaChiave", caption: "Parola Chiave", colSpan: '1', //nome del file
          width: 415,hideOnEdit:false,colVisible:true,disabled:false,disableOnUpdate:false,colWidth:'100px'
        }, //,editorClass:'bg-grey'
        
        

      ]
    },



];

export const tagAllegati : AnaColumn[] = [
  { 
    itemType: "group", colCount: "1",class:'float-start', data:[
      {
        maxLength: "60", maxSize: 60, type: 'campo', dataField: "parolaChiave", caption: "Parola Chiave", colSpan: '1', //nome del file
        width: 415,hideOnEdit:false,colVisible:true,disabled:false,disableOnUpdate:false,colWidth:'auto',
      }, //,editorClass:'bg-grey'
    ] 
  }  

];

  